import _app from '../../../server';

import React from 'react';
import PropTypes from 'prop-types';

import {
    panics_getHistory,
    panics_getFilteredHistory
} from 'redux/actions/panics';

import BootstrapTable from 'react-bootstrap-table-next';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import 'assets/css/customs.css';

import defPic from 'assets/img/icons/default_pic.jpg';
const moment = require('moment');


const PanicTable = ({
    md,
    lg,
    xl,
    panics,
    isFilterOn,
    filter,
    dispatch,
    token,
    onPanicRowClicked
}) => {
    const { byid, list, currentPage, itemPerPage } = panics;
    let data = [];
    let indexEnd = currentPage * itemPerPage;
    let indexStart = indexEnd - itemPerPage;

    if (indexEnd > list.length) {
        indexEnd = list.length;
    }

    let itemsList = list.slice(indexStart, indexEnd);
    let isItemNull = itemsList.find(e => {
        return e === -1;
    });
    if (!isItemNull) {

        data = [];
        let bil = indexStart + 1;

        itemsList.forEach(index => {
            const _history = byid[index];
            if (!_history.name) {
                return;
            }
            if (_history.name.length < 1) {
                return;
            }
            let names = _history.name.map(n => {
                return (
                    <p key={n} className='table-text-cont' >
                        {n}
                    </p >
                )
            });
            let staffIds = _history.staffId.map(n => {
                return (
                    <p key={n} className='table-text-cont' >
                        {n}
                    </p >
                )
            });
            let phones = _history.phoneNumber.map(n => {
                return (
                    <p key={n} className='table-text-cont' >
                        {n}
                    </p >
                )
            });


            const item = {
                id: index,
                trackerId: _history.trackerId,
                bil: `${bil}`,
                link: [],
                name: <div>{names}</div>,
                staffId: <div>{staffIds}</div>,
                callerId: _history.callerId,
                phoneNumber: <div>{phones}</div>,
                timestamp: moment(_history.timestamp).format('YYYY/MM/DD hh:mm:ss A')
            };

            for (let i = 0; i < _history.link.length; i++) {
                let img_link = defPic;
                if (_history.containers[i] !== null && _history.filename[i] !== null) {
                    img_link = `${_app.api}Storages/${_history.containers[i]}/download/${_history.filename[i]}?access_token=${token}`;
                } else if (_history.link[i] !== null) {
                    img_link = _history.link[i];
                }
                item.link = [...item.link, img_link];
            }

            data.push(item);
            bil++;
        });
    } else {
        if (isFilterOn) {
            dispatch(panics_getFilteredHistory(indexStart, itemPerPage, filter));
            return <p className='text-center'>Loading ....</p>;
        } else {
            dispatch(panics_getHistory(indexStart, itemPerPage));
            return <p className='text-center'>Loading ....</p>;
        }
    }

    let imgFormatter = (links) => {
        let avatars = links.map(link => {
            return (
                <div className='table-img-cont' key={link} style={{ padding: "5px" }}>
                    <img
                        src={link}
                        height='100%'
                        alt=''
                    />
                </div>
            )
        })
        return (
            <div>
                {avatars}
            </div>
        );
    }

    let columns = [
        {
            dataField: '',
            text: 'id',
            hidden: true,
            sort: true
        },
        {
            dataField: 'trackerId',
            text: 'Tracker ID',
            hidden: true,
            sort: true
        },
        {
            dataField: 'bil',
            text: '#',
            headerClasses: 'table-col-head',
            sort: true,
            headerStyle: { whiteSpace: 'nowrap', width: '3%' }
        },
        {
            dataField: 'link',
            text: ' ',
            headerClasses: "table-col-head",
            headerStyle: { "width": "90px" },
            formatter: imgFormatter,
            sort: false,
        },
        {
            dataField: 'name',
            text: 'Name',
            headerClasses: 'table-col-head',
            sort: true,
            headerStyle: { whiteSpace: 'nowrap', width: '40%' }
        },
        {
            dataField: 'staffId',
            text: 'Staff No',
            hidden: lg,
            headerClasses: 'table-col-head',
            sort: true
        },
        {
            dataField: 'callerId',
            text: 'Device',
            hidden: lg,
            headerClasses: 'table-col-head',
            sort: true,
        },
        {
            dataField: 'phoneNumber',
            text: 'Phone Number',
            hidden: md,
            headerClasses: 'table-col-head',
            sort: true,

        },
        {
            dataField: 'timestamp',
            text: 'Date/Time',
            headerClasses: 'table-col-head',
            headerStyle: { whiteSpace: 'wrap', width: '170px' },
            sort: true
        }
    ];

    const rowEvents = {
        onDoubleClick: (e, row) => {
            onPanicRowClicked({ id: row.id });
        }
    };

    return (
        <BootstrapTable
            bootstrap4
            classes='table-md table-responsive-sm text-center align-middle'
            keyField='id'
            data={data}
            columns={columns}
            striped
            hover
            condensed
            bordered={false}
            noDataIndication='Record not found'
            rowEvents={rowEvents}
        />
    );
};

PanicTable.propTypes = {
    md: PropTypes.bool,
    lg: PropTypes.bool,
    xl: PropTypes.bool,
    panics: PropTypes.object,
    isFilterOn: PropTypes.bool,
    filter: PropTypes.object,
    dispatch: PropTypes.func,
    token: PropTypes.string,
    onPanicRowClicked: PropTypes.func
};

export default PanicTable;



// WEBPACK FOOTER //
// ./src/components/blocks/PanicTable/PanicTable.js